<template lang="pug">
  v-list-item.sdo-radius.sdo-shadow.pr-0(
    v-if="meeting.id"
    link
    target="_blank"
    :href="meeting.conference.group.invite_link"
    :disabled="date(meeting.date_end)"
    :key="meeting.id"
  )
    v-list-item-icon.mt-2.mr-2: v-icon(color="primary" size="32") $telegram
    v-list-item-content
      .text-body-2.secondary--text: strong {{meeting.title}}
      .caption.grey--text.text--darken-1 {{ meeting.dateStart | dateprint_from_now}}
        //- strong {{ conferencePrefix(selectedConference.date_start) }}
    v-list-item-icon.mt-2.ml-2: v-icon(
      color="grey"
      dot size="18"
    ) mdi-broadcast

</template>
<script>
export default {
  props: {
    meeting: { type: Object, required: true },
    isTeacher: { type: Boolean, required: true },
  },
  data() {
    return {};
  },
  methods: {
    date(date) {
      return new Date() > new Date(`${date}Z`);
    },
  },
};
</script>
